import React from 'react';
import { ActionButton, Content, Dialog, DialogContainer, Divider, Heading } from '@adobe/react-spectrum';
import { getAnalytics, logEvent } from 'firebase/analytics';
import '../../common/searedDialog/searedDialog.css';
import './ManuelDialog.css';

const DISCORD_URL = 'https://discord.gg/Yb2CAxcJcf';

/**
 * Dialog opened from the deck-details "Field Report" card. Introduces
 * Manuel — the rude-ass Discord roast bot — and pushes users toward the
 * Discord where they can actually get roasted.
 *
 * Props:
 *   - isOpen: controls the modal (controlled from the parent so the
 *             Field Report click handler can toggle it)
 *   - onClose: close callback
 */
export function ManuelDialog({ isOpen, onClose }) {
    const handleDiscordClick = () => {
        logEvent(getAnalytics(), 'manuel_discord_click');
        window.open(DISCORD_URL, '_blank');
    };

    if (!isOpen) return null;

    return (
        <DialogContainer type="modal" isDismissable onDismiss={onClose}>
            <Dialog width="calc(100vw - 40px)" maxWidth={540} UNSAFE_className="searedDialog manuelDialog">
                <Heading>
                    <span className="searedDialog__eyebrow">Field Report</span>
                    <span className="searedDialog__title">Manuel, Nunchaku Specialist</span>
                    <span className="searedDialog__subtitle">The basement-dwelling AI living in our Discord</span>
                </Heading>
                <Divider />
                <Content>
                    <div className="searedDialog__body manuelDialog__body">
                        <div className="manuelDialog__avatarRow">
                            <img src="/resources/manuel_avatar.png" alt="Manuel" className="manuelDialog__avatar" />
                            <div className="manuelDialog__pitch">
                                <span className="manuelDialog__pitchEyebrow">WARNING — VERBAL DAMAGE INCOMING</span>
                                <p className="manuelDialog__pitchHeadline">
                                    Every deck gets roasted. Yours is not special.
                                </p>
                            </div>
                        </div>

                        <p className="searedDialog__paragraph">
                            Manuel is the Commandersalt Discord's resident AI nutcase. Drop him a deck link and
                            he&apos;ll tear through your list with the same salt-focused lens the site uses — tutors,
                            fast mana, stax, combo lines, the works — and then tell you exactly why your "casual" Kinnan
                            deck is a war crime. Does he hallucinate sometimes? Sure, all AIs do. Is it funny?
                            Definitely. Has he made a religion for himself based on buffalo? Absolutely.
                        </p>

                        <ul className="manuelDialog__featureList">
                            <li>
                                <span className="manuelDialog__featureHead">Roast imports</span>— drop in a deck URL,
                                get a field report that pulls no punches.
                            </li>
                            <li>
                                <span className="manuelDialog__featureHead">Salt audits</span>— Manuel reads your
                                saltiest cards out loud, with commentary.
                            </li>
                            <li>
                                <span className="manuelDialog__featureHead">Meta trivia</span>— ask about cEDH staples,
                                ban updates, bracket caps.
                            </li>
                            <li>
                                <span className="manuelDialog__featureHead">Grudge memory</span>— he remembers how salty
                                your decks were last time.
                            </li>
                        </ul>

                        <p className="searedDialog__paragraph manuelDialog__cta">
                            Want your deck flambéed? Come yell at Manuel in the Discord.
                        </p>

                        <div className="manuelDialog__actions">
                            <button type="button" className="manuelDialog__discordBtn" onClick={handleDiscordClick}>
                                <img
                                    src="/resources/discord.png"
                                    alt=""
                                    aria-hidden="true"
                                    className="manuelDialog__discordIcon"
                                />
                                <span className="manuelDialog__discordLabel">Join the Discord</span>
                            </button>
                            <ActionButton
                                onPress={onClose}
                                aria-label="Close"
                                UNSAFE_className="manuelDialog__dismissBtn"
                            >
                                <span>Maybe later</span>
                            </ActionButton>
                        </div>
                    </div>
                </Content>
            </Dialog>
        </DialogContainer>
    );
}
